var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import { Dependencies } from "~/core/decorator";
import { Emit, Prop } from "vue-property-decorator";
import { OutsourceStayService } from "~/services/domain-service/outsource-stay-manage.service";
import { OutsourceLawsuitStayService } from "~/services/domain-service/outsource-lawsuit-manage.service";
import { DISTRIBUTION_TYPE } from "~/config/enum.config";
var CaseDistribution = /** @class */ (function (_super) {
    __extends(CaseDistribution, _super);
    function CaseDistribution() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.patternCollection = DISTRIBUTION_TYPE;
        _this.dataSet = [];
        _this.model = {
            distributeMode: "BY_INTEGRATE",
            outEndDate: "",
            analyseId: ""
        };
        _this.companyRules = {
            outEndDate: [{ required: true, message: "请选择委外到期时间" }]
        };
        return _this;
    }
    /**
     * 刷新分案预览数据
     */
    CaseDistribution.prototype.refreshData = function () {
        var _this = this;
        var requestModel = {
            caseIds: this.selectedCaseIds,
            distributeMode: this.model.distributeMode,
            outsourceIds: this.commissionIds
        };
        if (!this.isLawsuit) {
            this.outsourceStayService
                .searchSplitPreview(requestModel)
                .subscribe(function (data) {
                _this.model.analyseId = data.analyseId;
                _this.dataSet = data.resDistModel;
            });
        }
        else {
            this.outsourceLawsuitStayService
                .searchSplitPreview(requestModel)
                .subscribe(function (data) {
                _this.model.analyseId = data.analyseId;
                _this.dataSet = data.resDistModel;
            });
        }
    };
    CaseDistribution.prototype.emitPre = function () {
        this.resetData();
    };
    CaseDistribution.prototype.emitClose = function () {
        this.resetData();
    };
    CaseDistribution.prototype.emitSuccess = function () {
        this.emitClose();
        this.$message.success("案件分配成功");
    };
    /**
     * 计算输入后当前行人员的案件总数
     */
    CaseDistribution.prototype.computAllotCaseCount = function (row) {
        var inputNum = Number.parseInt(row.num || "0");
        return inputNum + row.currentNum;
    };
    /**
     * 输入验证
     */
    CaseDistribution.prototype.onNumBlur = function (e) {
        if (e.target.valueAsNumber > this.selectedCaseIds.length) {
            this.$message.error(e.target.validationMessage);
        }
        else {
            var alreadySum = this.dataSet.reduce(function (a, c) { return a + Number.parseInt(c.num || "0"); }, 0);
            if (alreadySum > this.selectedCaseIds.length) {
                this.$message.error("输入数量不能大于选中分案数量");
            }
        }
    };
    CaseDistribution.prototype.resetData = function () {
        this.model.distributeMode = "BY_INTEGRATE";
        this.model.analyseId = "";
        var form = this.$refs.form;
        form.resetFields();
    };
    CaseDistribution.prototype.submit = function () {
        var _this = this;
        var form = this.$refs.form;
        form.validate(function (v) {
            if (!v)
                return;
            var caseCount = _this.dataSet.reduce(function (a, c) { return a + c.num; }, 0);
            if (caseCount > _this.selectedCaseIds) {
                _this.$message("确认分配案件数不能大于选择的案件总数");
                return;
            }
            _this.model.caseIds = _this.selectedCaseIds;
            _this.model.outsourceIds = _this.commissionIds;
            _this.model.distributeNumber = _this.dataSet.map(function (v) { return parseInt(v.num); });
            _this.model.distributeMode = _this.model.distributeMode;
            _this.distributionCase();
        });
    };
    CaseDistribution.prototype.distributionCase = function () {
        if (!this.isLawsuit) {
            this.outsourceStayService
                .confirmDistributeCase(this.model)
                .subscribe(this.emitSuccess);
        }
        else {
            this.outsourceLawsuitStayService
                .confirmDistributeCase(this.model)
                .subscribe(this.emitSuccess);
        }
    };
    Object.defineProperty(CaseDistribution.prototype, "isCustomerDistribution", {
        /**
         * 是否自定义分配
         */
        get: function () {
            return this.model.distributeMode === "BY_CUSTOMIZE";
        },
        enumerable: false,
        configurable: true
    });
    __decorate([
        Dependencies(OutsourceStayService)
    ], CaseDistribution.prototype, "outsourceStayService", void 0);
    __decorate([
        Dependencies(OutsourceLawsuitStayService)
    ], CaseDistribution.prototype, "outsourceLawsuitStayService", void 0);
    __decorate([
        Prop({
            required: true,
            default: function () { return []; }
        })
    ], CaseDistribution.prototype, "selectedCaseIds", void 0);
    __decorate([
        Prop({
            required: true,
            default: function () { return []; }
        })
    ], CaseDistribution.prototype, "commissionIds", void 0);
    __decorate([
        Prop({ required: true })
    ], CaseDistribution.prototype, "isLawsuit", void 0);
    __decorate([
        Emit("pre")
    ], CaseDistribution.prototype, "emitPre", null);
    __decorate([
        Emit("close")
    ], CaseDistribution.prototype, "emitClose", null);
    __decorate([
        Emit("success")
    ], CaseDistribution.prototype, "emitSuccess", null);
    CaseDistribution = __decorate([
        Component({
            components: {}
        })
    ], CaseDistribution);
    return CaseDistribution;
}(Vue));
export default CaseDistribution;
